export const ARRAY_BUFFER_RESPONSE_TYPE = 'arraybuffer';
